(function () {
  'use strict';

  var isInternetEmpresas = (window.sdkConfigWebComponent && window.sdkConfigWebComponent.frameworkDA != undefined) ? (window.sdkConfigWebComponent.frameworkDA === false) : false;
  var isNf2 = window.self === window.top;
  const DEFAULT_GTM_CONTAINER = "W2D4FGX";
  const shouldProcessConsolidation = sessionStorage.sessaoVisaoCliente !== "true" && isNf2;

  let consolidationEventQueue = [];

  if (isInternetEmpresas && !window._containerGTM) {
    window._containerGTM = DEFAULT_GTM_CONTAINER;
  }

  window.ItauDigitalAnalytics = {};

  function dispatchConsolidationEvent(analyticsPayload) {
    if (!shouldProcessConsolidation) return;

    const customEvent = new CustomEvent('data-consolidation-collect', {
      detail: {
        payload: analyticsPayload
      }
    });

    window.dispatchEvent(customEvent);
  }

  var sdkScriptTag = document.createElement("script");
  if (isInternetEmpresas) {
    sdkScriptTag.src = "https://sdk-analytics-web.cloud.itau.com.br/index.js";
  } else {
    sdkScriptTag.src = "https://libs-digitalanalytics.cloud.itau.com.br/assets/framework-analytics-web.min.js";
  }

  var analyticsTagElement = document.createElement("framework-analytics-web");

  var scriptLoadedPromise = new Promise(function (resolve) {
    sdkScriptTag.onload = function () {
      document.body.appendChild(analyticsTagElement);

      function configureGTM(gtmCode) {
        window._containerGTM = gtmCode;
      }

      function configureSDKAnalytics(configObject) {
        if (configObject.gtm === undefined) {
          configObject.gtm = window._containerGTM;
        }
        var sdk = window.SDKAnalytics(configObject);

        const sdkMethods = [
          "measurementTrack",
          "removeAllDefaultParameters",
          "removeDefaultParameter",
          "removeDefaultParameters",
          "removeUserProperties",
          "setDefaultParameters",
          "track",
          "Track",
        ];
        sdkMethods.forEach((methodName) => {
          window.ItauDigitalAnalytics[methodName] = sdk[methodName];
        });

        window.ItauDigitalAnalytics._userProperties = sdk.setUserProperties;
        window.ItauDigitalAnalytics.setUserProperties = sdk.setUserProperties;
        window.ItauDigitalAnalytics.clientID = (configObject.engagement && configObject.engagement.clientID) ? configObject.engagement.clientID : "";

        return window.ItauDigitalAnalytics;
      }

      function setDefaultParameters(paramData) {
        window.ItauDigitalAnalytics.setDefaultParameters(getAnalyticsParam(paramData));
      }

      function getAnalyticsParam(paramData) {
        const result = paramData.analytics !== undefined ? paramData : { analytics: paramData };
        const defaultStatus = "arquitetura-tag-ga4-pj-cdn-web";
        
        if (!result.analytics.parameters) {
          result.analytics.parameters = {};
        }
        
        if (result.analytics.parameters.status && result.analytics.parameters.status !== defaultStatus) {
          result.analytics.parameters.status += "|" + defaultStatus;
        } else {
          result.analytics.parameters.status = defaultStatus;
        }
        return result;
      }

      function measurementTrackEvent(eventData) {
        return window.ItauDigitalAnalytics.measurementTrack(getAnalyticsParam(eventData));
      }

      function deleteAllDefaultParameters() {
        return window.ItauDigitalAnalytics.removeAllDefaultParameters();
      }

      function deleteDefaultParameter(paramName) {
        return window.ItauDigitalAnalytics.removeDefaultParameter(paramName);
      }

      function deleteDefaultParameters(paramNames) {
        return window.ItauDigitalAnalytics.removeDefaultParameters(paramNames);
      }

      function deleteUserProperties() {
        return window.ItauDigitalAnalytics.removeUserProperties();
      }

      function clearEventQueue() {
        consolidationEventQueue = [];
      }

      function trackEvent(eventData) {
        if (window.ItauDigitalAnalytics.clientID &&
          window.trackingId &&
          window.ItauDigitalAnalytics.clientID !== window.trackingId) {
          window.ItauDigitalAnalytics.configureSDKAnalytics(window.objconfigureSDKAnalytics);
        }

        const processedEventData = getAnalyticsParam(eventData);
        window.ItauDigitalAnalytics.track(processedEventData);

        if (!shouldProcessConsolidation) return;

        if (!!window._analyticsConsolidationReady) {
          if (consolidationEventQueue.length > 0) {
            consolidationEventQueue.forEach((queuedEvent) => {
              dispatchConsolidationEvent(queuedEvent);
            });
            clearEventQueue();
          }
          dispatchConsolidationEvent(processedEventData);
        } else {
          consolidationEventQueue.push(processedEventData);
          validateConsolidationInit();
        }
      }

      function TrackEvent(paramData) {
        if (!paramData) {
          paramData = window.analyticsData;
        }
        window.ItauDigitalAnalytics.Track(getAnalyticsParam(paramData));
      }

      function setUserProperties(paramData) {
        window.ItauDigitalAnalytics._userProperties(getAnalyticsParam(paramData));
      }

      function dataStreamCombineUser() {
        return { ...getStoredUser(), ...getStoredParams() };
      }

      if (isInternetEmpresas) {
        window.ItauDigitalAnalytics = configureSDKAnalytics(window.objconfigureSDKAnalytics || {});
        window.ItauDigitalAnalytics.configureSDKAnalytics = configureSDKAnalytics;
        window.ItauDigitalAnalytics.measurementTrackEvent = measurementTrackEvent;
        window.ItauDigitalAnalytics.deleteAllDefaultParameters = deleteAllDefaultParameters;
        window.ItauDigitalAnalytics.deleteDefaultParameter = deleteDefaultParameter;
        window.ItauDigitalAnalytics.deleteDefaultParameters = deleteDefaultParameters;
        window.ItauDigitalAnalytics.deleteUserProperties = deleteUserProperties;
        window.ItauDigitalAnalytics.TrackEvent = TrackEvent;
      }

      window.ItauDigitalAnalytics.configureGTM = configureGTM;
      window.ItauDigitalAnalytics.defaultParameters = setDefaultParameters;
      window.ItauDigitalAnalytics.trackEvent = trackEvent;
      window.ItauDigitalAnalytics.dataStreamCombineUser = dataStreamCombineUser;

      if (typeof window.ItauDigitalAnalytics._userProperties === "undefined") {
        window.ItauDigitalAnalytics._userProperties = window.ItauDigitalAnalytics.setUserProperties;
        window.ItauDigitalAnalytics.setUserProperties = setUserProperties;
      }

      if (shouldProcessConsolidation) {
        validateConsolidationInit();
      }

      resolve();
    };
  });

  document.head.appendChild(sdkScriptTag);
  window.ItauDigitalAnalytics.scriptLoadedPromise = scriptLoadedPromise;

  function validateConsolidationInit() {
    let consolidationURL = sessionStorage.getItem("analyticsConsolidationURL");
    let isConsolidationInitialized = !!(consolidationURL && !!window._analyticsConsolidationReady);
    let hasMonitoredSetItem = false;

    if (consolidationURL) {
      initializeAnalyticsConsolidation(consolidationURL);
      return;
    }

    if (!hasMonitoredSetItem) {
      hasMonitoredSetItem = true;
      const originalSetItem = sessionStorage.setItem.bind(sessionStorage);

      sessionStorage.setItem = (keyName, keyValue) => {
        originalSetItem(keyName, keyValue);

        if (isConsolidationInitialized || keyName !== "analyticsConsolidationURL") return;


        if (keyName === "analyticsConsolidationURL" && keyValue) {
          consolidationURL = keyValue;
          isConsolidationInitialized = true;
          sessionStorage.setItem = originalSetItem;

          initializeAnalyticsConsolidation(consolidationURL);
        }
      };
    }
  }

  function initializeAnalyticsConsolidation(consolidationURL) {
    if (!!window._analyticsConsolidationReady) return;
    if (!document.querySelector("data-consolidation-wrapper")) {
      const wrapperElement = document.createElement("data-consolidation-wrapper");
      wrapperElement.style.display = "none";
      document.body.appendChild(wrapperElement);
    }

    loadConsolidationScripts([consolidationURL + "main.js"]);
  }

  function loadConsolidationScripts(scriptURLs) {
    return Promise.all(
      scriptURLs.map((scriptURL) =>
        new Promise((resolve, reject) => {
          const scriptElement = document.createElement("script");
          scriptElement.src = scriptURL;
          scriptElement.defer = true;
          scriptElement.onload = () => resolve(scriptURL);
          scriptElement.onerror = (error) => reject(error);
          document.body.appendChild(scriptElement);
        })
      )
    );
  }

  var lastUserRaw = null, cachedUser = {};
  var lastParamsRaw = null, cachedParams = {};

  function getStoredUser() {
    var raw = sessionStorage.getItem("_storage_analytics_user") ||
      localStorage.getItem("_storage_analytics_user") || "{}";

    if (raw !== lastUserRaw) {
      lastUserRaw = raw;
      try {
        cachedUser = JSON.parse(raw);
        delete cachedUser.pj_id;
      } catch (e) {
        cachedUser = {};
      }
    }
    return cachedUser;
  }

  function getStoredParams() {
    var raw = sessionStorage.getItem("_storage_analytics_parameters") ||
      localStorage.getItem("_storage_analytics_parameters") || "{}";

    if (raw !== lastParamsRaw) {
      lastParamsRaw = raw;
      try {
        cachedParams = JSON.parse(raw);
      } catch (e) {
        cachedParams = {};
      }
    }
    return cachedParams;
  }
})();
